import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IBimehNamehShakhsSalesSaderShodehQuery } from '../SakhsSalesBimehNameh/Queries/IBimehNamehShakhsSalesSaderShodehQuery';
import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export const bimehNamehShakhsSalesSaderShodeh = createAsyncThunk(
  'ParvandehKhesarat/bimehNamehShakhsSalesSaderShodeh',
  async (query: IBimehNamehShakhsSalesSaderShodehQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.BimehNamehShakhsSalesSaderShodeh}`,
      params: query,
    });
  }
);
